import { useRef, useState } from "react";
import MetricsScreen from "./MetricsScreen";
import { apiFetch } from "../utils/api";
import { getAuthHeaders } from "../utils/auth";
import "../styles/AdminScreen.scss";

const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:8080";

export default function AdminScreen() {
  const [isExporting, setIsExporting] = useState(false);
  const [exportError, setExportError] = useState("");
  const exportInProgress = useRef(false);

  const downloadParticipants = async () => {
    if (exportInProgress.current) return;
    exportInProgress.current = true;
    setIsExporting(true);
    setExportError("");
    try {
      const response = await apiFetch(`${API_BASE}/users/export`, {
        headers: getAuthHeaders(),
      });
      if (!response.ok) {
        throw new Error(
          response.status === 403
            ? "Скачивание доступно только администраторам."
            : "Не удалось скачать данные участников. Попробуйте ещё раз.",
        );
      }
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `participants_${new Date().toISOString().slice(0, 10)}.xlsx`;
      document.body.appendChild(link);
      try {
        link.click();
      } finally {
        link.remove();
        // Браузеру нужно время, чтобы начать чтение файла для скачивания.
        window.setTimeout(() => URL.revokeObjectURL(url), 1000);
      }
    } catch (error) {
      setExportError(error.message || "Не удалось скачать данные участников.");
    } finally {
      exportInProgress.current = false;
      setIsExporting(false);
    }
  };

  return (
    <div className="admin-screen">
      <header className="admin-screen__header">
        <h1>Админ-панель</h1>
        <p>Инструменты управления и показатели платформы.</p>
      </header>

      <section className="admin-screen__tools" aria-labelledby="admin-tools-title">
        <h2 id="admin-tools-title">Администрирование</h2>
        <div className="admin-screen__export">
          <div className="admin-screen__export-description">
            <h3>Данные участников</h3>
            <p>Все участники и поля профилей в Excel: ФИО, контакты, роли, технологии и другие данные.</p>
            <span className="admin-screen__format">XLSX · Нумерация строк · Фильтры по столбцам</span>
          </div>
          <button
            className="admin-screen__download"
            type="button"
            onClick={downloadParticipants}
            disabled={isExporting}
            aria-busy={isExporting}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
              <path d="M12 3v12m-5-5 5 5 5-5M4 16v5h16v-5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            {isExporting ? "Подготовка файла…" : "Скачать данные участников"}
          </button>
        </div>
        {exportError && <p className="admin-screen__error" role="alert">{exportError}</p>}
      </section>

      <MetricsScreen />
    </div>
  );
}
